module.exports = __webpack_public_path__ + "static/media/guide-line-01.e0ee3d55.svg";